module.exports = __webpack_public_path__ + "static/media/delixpress_round_logo.3973a173.png";